export default {
  UPDATE_CHATMAIL_SYNC: 'UPDATE_CHATMAIL_SYNC'
}